import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { NewPriceCategoryButton } from "PriceCategories/Components/NewPriceCategoryButton";
import { PriceCategoriesTable } from "PriceCategories/Components/PriceCategoriesTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const PriceCategoriesPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      preTitle={t(Resources.Common.Admin)}
      title={t(Resources.Common.PriceCategories)}
      action={<NewPriceCategoryButton />}
    >
      <Stack spacing={Spacing.L}>
        <PriceCategoriesTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
